module.exports = __webpack_public_path__ + "img/0Q3A3001_L_WoodMatted_MockedUp.06ff39eb.jpg";